var _style, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParentsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-back-to-school",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-back-to-school:not(.animated) .animable {opacity: 0;}svg#freepik_stories-back-to-school.animated #freepik--Floor--inject-277 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-back-to-school.animated #freepik--Shadows--inject-277 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-back-to-school.animated #freepik--Plants--inject-277 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideRight;animation-delay: 0s;}svg#freepik_stories-back-to-school.animated #freepik--character-3--inject-277 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight;animation-delay: 0s;}svg#freepik_stories-back-to-school.animated #freepik--character-2--inject-277 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-back-to-school.animated #freepik--characters-1--inject-277 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}svg#freepik_stories-back-to-school.animated #freepik--speech-bubble--inject-277 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-back-to-school.animated #freepik--Sign--inject-277 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-back-to-school.animated #freepik--Clouds--inject-277 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedLeft;animation-delay: 0s;}            @keyframes lightSpeedLeft {              from {                transform: translate3d(-50%, 0, 0) skewX(20deg);                opacity: 0;              }              60% {                transform: skewX(-10deg);                opacity: 1;              }              80% {                transform: skewX(2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideRight {                0% {                    opacity: 0;                    transform: translateX(30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-277",
    className: "animable",
    style: {
      transformOrigin: "248.78px 354.38px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--floor--inject-277",
    className: "animable",
    style: {
      transformOrigin: "248.78px 354.38px"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-277",
    cx: 248.78,
    cy: 354.38,
    rx: 231.53,
    ry: 129.83,
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "248.78px 354.38px"
    },
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.5,446.19a181.08,181.08,0,0,0,34-24.19L134,241.6a265.29,265.29,0,0,0-49,21C35.94,290.13,13.51,327,17.77,363l208.89,120.6C293.05,487.18,361.65,474.7,412.5,446.19Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "231.88px 362.899px"
    },
    id: "el6yvkgwyqfi3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfxyspgwmoi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.5,446.19a181.08,181.08,0,0,0,34-24.19L134,241.6a265.29,265.29,0,0,0-49,21C35.94,290.13,13.51,327,17.77,363l208.89,120.6C293.05,487.18,361.65,474.7,412.5,446.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.8,
      transformOrigin: "231.88px 362.899px"
    },
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-277",
    className: "animable",
    style: {
      transformOrigin: "244.851px 358.02px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-277"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 276.86,
    cy: 382.36,
    rx: 49.86,
    ry: 28.79,
    style: {
      opacity: 0.1,
      transformOrigin: "276.86px 382.36px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-277"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.88,
    cy: 343.49,
    rx: 49.86,
    ry: 28.79,
    style: {
      opacity: 0.1,
      transformOrigin: "403.88px 343.49px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-277"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.42,314.64c-22.46-13-58.88-13-81.35,0a47.83,47.83,0,0,0-7,4.95c-.5-.31-1-.62-1.52-.92-20.27-11.7-53.12-11.7-73.39,0s-20.26,30.67,0,42.37,53.12,11.7,73.39,0a42.34,42.34,0,0,0,3.87-2.51,49.59,49.59,0,0,0,4.7,3.08c22.47,13,58.89,13,81.35,0S236.89,327.61,214.42,314.64Z",
    style: {
      opacity: 0.1,
      transformOrigin: "133.628px 338.125px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-277",
    className: "animable",
    style: {
      transformOrigin: "449.207px 308.728px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-277",
    className: "animable",
    style: {
      transformOrigin: "449.207px 308.728px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.35,323s-2.4-14,1.29-26.51,11.05-21.75,19.5-24.95,17.75,2.73,10.08,10.89-22.49,18.51-24.12,41.15Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "446.829px 297.119px"
    },
    id: "elf4wnxuqwbz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eld6xqa8iggma"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "446.829px 297.119px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.35,323s-2.4-14,1.29-26.51,11.05-21.75,19.5-24.95,17.75,2.73,10.08,10.89-22.49,18.51-24.12,41.15Z",
    id: "el2gta1vm0az4",
    className: "animable",
    style: {
      transformOrigin: "446.829px 297.119px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M431.86,318.7h-.1a.47.47,0,0,1-.43-.52c2.6-25.14,17.25-39.58,24.64-43.7a.48.48,0,1,1,.46.84c-7.23,4-21.59,18.21-24.14,43A.5.5,0,0,1,431.86,318.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "444.018px 296.552px"
    },
    id: "el0ed5uyl9kstk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.63,310.36c-1.34,3.91-8.12,3.84-7.94,8.59a34.21,34.21,0,0,0,.87,3.7c.58,3.88-2.51,6.58-5.93,7.31s-7.7-1.12-10.88,1.08c-2.34,1.62-2.83,4.78-3.95,7.39a13,13,0,0,1-.72,1.45A14.65,14.65,0,0,1,441,345a12.73,12.73,0,0,1-7.39,1.77,5.51,5.51,0,0,1-3.08-.88,4.64,4.64,0,0,1-1.6-2.52,11.62,11.62,0,0,1-.33-2.27,11.28,11.28,0,0,0-.44-1.78c-.91-3.43-1.24-7.52-3.35-10.46-2.41-3.38-1-8.77,1.93-11.4,2.71-2.47,6.77-3.33,8.91-6.31,1.06-1.48,1.51-3.3,2.39-4.89a10.29,10.29,0,0,1,9-5.19c2.67.05,5.16,1.12,7.75,1.63a22,22,0,0,0,6.77-.08c4.06-.46,9.13-.67,12,2.88A5.26,5.26,0,0,1,474.63,310.36Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "449.207px 323.935px"
    },
    id: "elvf4pyrzxk1k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.22,339h0a.42.42,0,0,1-.33-.5c5.54-26.28,32.65-31.46,39.06-31.34a.43.43,0,0,1,0,.86c-6.28-.13-32.79,4.94-38.22,30.66A.41.41,0,0,1,430.22,339Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "449.629px 323.086px"
    },
    id: "eldkbbbx6n8ea",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.87,324.23a.36.36,0,0,1-.23-.11,22.77,22.77,0,0,0-18.86-4.25.43.43,0,0,1-.5-.34.42.42,0,0,1,.33-.5,23.61,23.61,0,0,1,19.6,4.46.43.43,0,0,1,0,.61A.44.44,0,0,1,459.87,324.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "450.304px 321.356px"
    },
    id: "eljpw9450a3w9",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-277",
    className: "animable",
    style: {
      transformOrigin: "406.137px 228.224px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Teacher--inject-277",
    className: "animable",
    style: {
      transformOrigin: "406.137px 228.224px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.41,194.17a57.4,57.4,0,0,0,9.08-1.91s-5-1-5.38-3.14c-.46-2.6,2.75-.11,7.25-.75,4-.56,7.36.16,9.4-.43l23.59-8.57s10.86-23.49,13.95-26.94,6.3-4.27,10.93-4.88l-2.91,19.6s-8.36,15.79-10.71,19.64-3.23,4-8.83,5.86c-7.38,2.4-18.74,4.68-25.14,6.74-7.62,2.44-14.57,5.1-19.31,3.24a8.31,8.31,0,0,1-4.4-3.66C322.09,197.15,320.46,194.65,325.41,194.17Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "358.108px 175.402px"
    },
    id: "ell83o7e7xg1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.23,147.55s-5.66.33-8.14,1.63c-3.18,1.68-5.22,6.17-8.4,12.38s-5.85,12.51-5.85,12.51,6.19,5.81,11.69,7.56l9.52-15.42Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "383.035px 164.59px"
    },
    id: "elqonb4wkgbi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.19,327.81l-1.32-1.69c-.64,3.9-4.35,8.25-7.89,11.49-2.82,2.57-7,5.72-6.92,8.36.13,3.14,5.35,4,8,3.51,3.07-.54,7-2.28,9.18-4.92,1.52-1.87,3.66-4.31,4.74-5.77s3.58-3.1,4.16-4.79c.32-.94-.06-3-.51-4.7s-.86-3.31-1.4-3.17v1c-.65.72-3.63,1.67-5.65,1.74C387.25,328.9,386.18,328.81,386.19,327.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "383.159px 337.864px"
    },
    id: "el6dad5tj70sa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.22,333.85a44.1,44.1,0,0,1,.69,7.23c.08,4.39.89,5.94,1,9.54.12,4.12-.74,6.68-2.41,9s-7,3.26-8.86-.65-1.61-6.46-1-10.5.69-6.48,1.05-9.66c.31-2.81.68-4.94.68-4.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "425.556px 347.741px"
    },
    id: "el44vjxeh9w7q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.07,283.82c-1-10.58-2.55-15-2.75-17.42,0,0,1.54-22.49,2.17-43.51.31-10.12-1.09-18.49-8.4-30.5l-35.35-5.6c-3.78,14-7.58,65.36-6.05,80.5.88,8.78,3.54,53.21,3.54,53.21V324a9.63,9.63,0,0,1-1.66,4.84,42.51,42.51,0,0,1-5.64,7.69,41,41,0,0,0-2.78,3.26c-2.18,2.55-.47,3.61,2.89,3.16,3.55-.47,6.52-3.22,8.08-5.38,2.33-3.22,7.61-8.4,8-10.26l0,0v-.22h0s.21-2.8.5-6.16,5.79-30.55,5.91-40.31a78.35,78.35,0,0,0-1.16-11.56l3.85-35.72s6,25.59,7.39,36.44c1.19,9.41,6.29,37.18,9.14,49.7a61.81,61.81,0,0,1,1.52,14.34v0c0,1.39-.46,12.5,0,15.64.88,6.56,6.71,6,7.85.74,1-4.45,1-14.69,1.06-16.39,0-1.23.1-2.6.17-4.06C430.48,328.89,433.26,296.15,432.07,283.82Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "403.271px 270.526px"
    },
    id: "elewz7l46zg1s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.33,193.66c-.91,6.15-2.49,14.29-3.88,28.12a395.83,395.83,0,0,0-1.67,41.73c.27,8.8.94,16.5.94,16.5s7.71,6.51,25.13,6.86,25.52-5.68,25.52-5.68l-2.23-14.75s2.11-34.17,2.23-45.9-3.59-20.1-9.28-28.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "406.56px 239.637px"
    },
    id: "el7q2hpnxqm7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413,147.9l6.25.27c-1.85,11,6.54,20.88,6.54,20.88l-3.46,17.41c.19.3-.52,2.79.79,5.93-6,8.07-30,9-36.76,1.27.37-3.23.66-5.43.74-7.35l-1.52-9.11c-9.24-9.65,1.67-23.24,8.68-29.65l6.46-.47Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "403.909px 173.029px"
    },
    id: "elhspgd75t9k4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.36,161.33c8.18.62,14.55-8.09,15.55-13.31l5.31.15,7.62,23.48s-2.68,10.17-3.61,13.8a10.11,10.11,0,0,0,1.24,8.21,78,78,0,0,1,5.61,10.62s-3.53,3-13,5a54.27,54.27,0,0,1-16.28.62l-1.65-11.16-3.05,10.31s-6.94-.56-12-4.29l3-18.49-1.25-7.52s-4.34-4.54-4.71-9.76,2.28-9.63,6-14.48a30.29,30.29,0,0,1,7.15-7l3.49-.26S390.16,160.7,398.36,161.33Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "405.593px 178.747px"
    },
    id: "el7rxqahbdhu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwlokxw6wu4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.36,161.33c8.18.62,14.55-8.09,15.55-13.31l5.31.15,7.62,23.48s-2.68,10.17-3.61,13.8a10.11,10.11,0,0,0,1.24,8.21,78,78,0,0,1,5.61,10.62s-3.53,3-13,5a54.27,54.27,0,0,1-16.28.62l-1.65-11.16-3.05,10.31s-6.94-.56-12-4.29l3-18.49-1.25-7.52s-4.34-4.54-4.71-9.76,2.28-9.63,6-14.48a30.29,30.29,0,0,1,7.15-7l3.49-.26S390.16,160.7,398.36,161.33Z",
    style: {
      opacity: 0.2,
      transformOrigin: "405.593px 178.747px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M400.78,154.55s8.37-1.84,11.94-6.91l0-3c2.09.35,2.57,3.76,2.57,3.76a10.94,10.94,0,0,1-2.66,6c-2.46,2.75-6.4,1.37-6.4,1.37s-1.87,2.21-2.83,2.46S400.78,154.55,400.78,154.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "408.035px 151.441px"
    },
    id: "elr9uvf7undfe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.78,154.55c-1.2-1.11-1.86-4.52-1.16-7.46,0-.23,0-2.48,0-2.48a1.63,1.63,0,0,0-1.34.55l-2.42,2.26a7.3,7.3,0,0,0-1.05,4.15,3.43,3.43,0,0,0,1.82,2.84,7.57,7.57,0,0,0,.11,2.61C397.06,157.7,400.78,154.55,400.78,154.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "397.79px 150.861px"
    },
    id: "elackd2ruskem",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.86,194.7a57.4,57.4,0,0,1-9.08-1.91s5-1,5.38-3.14c.46-2.59-2.75-.11-7.25-.74-4-.57-7.35.15-9.4-.44l-23.59-8.56S432.06,156.41,429,153s-5.11-4.19-9.75-4.8c-2.55,10.29-1.56,18.49,4.1,24,0,0,6,11.35,8.34,15.19s3.23,4,8.83,5.87c7.39,2.39,18.74,4.67,25.14,6.73,7.62,2.44,14.57,5.1,19.31,3.24a8.27,8.27,0,0,0,4.4-3.66C490.18,197.68,491.81,195.18,486.86,194.7Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "454.105px 176.027px"
    },
    id: "el7efp05t8jp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.7,148.14a15.06,15.06,0,0,1,7.61,1.82c2.14,1.37,3.8,3.39,6.9,9.1s8.14,16.39,8.14,16.39-2.44,5.84-13.2,7l-5.7-10s-4.07-5.48-5.06-11.29A25.35,25.35,0,0,1,418.7,148.14Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "429.207px 165.292px"
    },
    id: "elu3gbncbvad9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.59,131c-2-2.11-3.34-4.73-4.91-7.16a14.61,14.61,0,0,0-2.21-3.07c-.84-.74-1.89-1.22-2.69-2a6.51,6.51,0,0,1-2-4,4,4,0,0,1,2.07-3.84,5.92,5.92,0,0,1-1.25-4.63,5.53,5.53,0,0,1,6.7-4.56,5,5,0,0,1,2.14-5.92,8.19,8.19,0,0,1,6.65-.54,24.54,24.54,0,0,1,6,3.11l.11.07c4.8,3.08,10.28,4,14.6,8.06a17.58,17.58,0,0,1,5.72,14.26c-.49,11.33-9.63,17.14-12.72,20.47-.15.15-1.2.05-1.4.06l-3.13.15c-.76,0-1.72.44-2.44.21-.95-.31-1.67-1.57-2.23-2.32C400,136,396.4,134,393.59,131Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "403.165px 118.276px"
    },
    id: "elpprqovrbr7j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,132.74c.19-3.12.53-6.22.86-9.32.31-2.83-.73-6.94-3.47-8.32-.66-.33-1.44-.58-1.76-1.24a1.52,1.52,0,0,1,.19-1.52c1.41-1.93,5.57-1.11,7.41-.41a10,10,0,0,1,5.49,4.9c1.41,3,1.25,6.43,1.22,9.73s.16,6.82,2.09,9.49c1.2,1.66,3,2.81,4.49,4.17s2.93,3.12,3,5.17a5.86,5.86,0,0,1-3,5c-4.44,2.65-11,.8-14.12-3.13-2.24-2.79-2.58-6.63-2.56-10.21C425.86,135.59,425.92,134.16,426,132.74Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "433.514px 131.387px"
    },
    id: "elo0e32a3xist",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.12,127.27c.24,10.45,3.63,13,5.33,13.78s5,.29,8.17-.24v6.28s-1.83,4.6,1.16,7.46c6.88-1.23,10.51-4.75,11.45-5.86a2.27,2.27,0,0,0,.53-1.45V132.48s1.74,1.85,4.83-.27a5.69,5.69,0,0,0,1.46-8.27c-1.34-1.58-4.76-1.69-6.4.76-.92,1.81-1,3.62-2.08,2.87-2.75-2-1.27-6.49-4.6-8.72h0a22.7,22.7,0,0,0-3.38-1.48c-5.94-2.05-11.07-3.77-12.31-7.83C387.92,110.93,385.83,114.93,386.12,127.27Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "403.161px 132.045px"
    },
    id: "elid6ddvgq4q8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.72,125.19a1.41,1.41,0,1,0,1.48-1.39A1.44,1.44,0,0,0,397.72,125.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "399.13px 125.209px"
    },
    id: "eldanpk7tgm98",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.45,124.55a1.35,1.35,0,0,0,1.26,1.44,1.28,1.28,0,0,0,1.39-1.32,1.35,1.35,0,0,0-1.26-1.44A1.36,1.36,0,0,0,387.45,124.55Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "388.775px 124.612px"
    },
    id: "eloe1qctyzjhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.62,140.81c3.36-.44,10.28-2.43,11.36-5.16a7.12,7.12,0,0,1-2.43,3.49c-2.06,1.77-8.93,3.76-8.93,3.76Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "405.3px 139.275px"
    },
    id: "el8zb6r2lccd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.79,119.18l3.42,1.1A1.89,1.89,0,0,0,401,118,1.75,1.75,0,0,0,398.79,119.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "400.533px 119.099px"
    },
    id: "el0ta3x2u4bmr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400,133.18l-4.41,1.53a2.28,2.28,0,0,0,2.92,1.5A2.34,2.34,0,0,0,400,133.18Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "397.865px 134.756px"
    },
    id: "elccy7a5inh0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.87,119.49l3.5-.92a1.73,1.73,0,0,0-2.15-1.32A1.9,1.9,0,0,0,386.87,119.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "388.598px 118.339px"
    },
    id: "elr0upczlbj6g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.59,120.94l11.76,1.86a4.32,4.32,0,0,0-3.2,1.29l-8.56-1.27Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "410.47px 122.515px"
    },
    id: "elrf0ct1t07x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.71,121.11a2.35,2.35,0,0,0,.55,1.27,1.05,1.05,0,0,1,.22.45,22.26,22.26,0,0,0,.74,3.39,3.86,3.86,0,0,0,3.72,2.48,5.21,5.21,0,0,0,1.28-.07l.1,0a3.81,3.81,0,0,0,1.05-.37l.06,0,.09-.06.12-.07.1-.07.12-.09.11-.09a1.8,1.8,0,0,0,.2-.19,4.82,4.82,0,0,0,.87-1.26c.57-1.17.46-2.82,1.36-3l.11,0h.11c1.22,0,1,1.84,1.7,3.14a4.56,4.56,0,0,0,4.38,2.68h.61a6,6,0,0,0,.64-.07l.2,0,.19,0,.12,0a4,4,0,0,0,.72-.31l.25-.15c.15-.11.28-.22.42-.34a4,4,0,0,0,.82-1.18,21.3,21.3,0,0,0,.8-3.32,1.43,1.43,0,0,1,.21-.49,2.23,2.23,0,0,0,.62-1.19,1,1,0,0,0-.71-1.07l-.65-.1a20.68,20.68,0,0,0-6.41-.08c-2,.49-2.77,1.11-3.9,1.06s-1.74-.71-3.65-1.36a17.94,17.94,0,0,0-6-.44l-.6,0A1,1,0,0,0,382.71,121.11Zm13.35,1.54a1.73,1.73,0,0,1,.59-.44l.11-.06.06,0,.29-.13.26-.1c.27-.09.57-.17.88-.24l.35-.07c.29,0,.59-.09.89-.12h.21a5.33,5.33,0,0,1,3.61.77c.46.41.21,2.15,0,3v.07l0,.06a3.15,3.15,0,0,1-.09.36l-.07.22h0c0,.12-.09.24-.14.37h0l-.06.12a.3.3,0,0,1,0,.08.3.3,0,0,1,0,.08.54.54,0,0,0,0,.11l-.07.11-.08.13-.09.12a3.11,3.11,0,0,1-2.77,1.18,3.84,3.84,0,0,1-2.87-1.13h0a3.9,3.9,0,0,1-.91-1.81A4,4,0,0,1,396.06,122.65Zm-11.5-1.19a1.47,1.47,0,0,1,.49-.28l0,0,.22-.07.13,0,.11,0h.1l.1,0a3,3,0,0,1,.46-.06l.24,0h.8a7.73,7.73,0,0,1,.9.1,5.65,5.65,0,0,1,3.2,1.45,4.22,4.22,0,0,1,.06,2.69,4.58,4.58,0,0,1-.19.66.08.08,0,0,0,0,0l0,.06,0,0a.59.59,0,0,1,0,.08s-.05.1-.07.16,0,.09-.08.14l0,0-.06.1a.56.56,0,0,0-.05.08h0a3.11,3.11,0,0,1-2.94,1.21,3.6,3.6,0,0,1-1.46-.37,4,4,0,0,1-1.84-2.93C384.37,123.6,384.14,121.84,384.56,121.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "394.008px 124.692px"
    },
    id: "elkklcnpypnf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.9,123.42v8.44l-4.63-1.43,4.3-7.06A1,1,0,0,1,393.9,123.42Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "391.585px 127.615px"
    },
    id: "elx2n1qly6ep8",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-277",
    className: "animable",
    style: {
      transformOrigin: "288.223px 290.395px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Girl--inject-277",
    className: "animable",
    style: {
      transformOrigin: "288.223px 290.395px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298,242.09a16.19,16.19,0,0,1,10.25,2.32c3.09,2.07,17.34,14.93,17.34,14.93-.69,1.54-6,5.61-7.66,5.76l-9.68,0s-4.05-7.48-5.66-11.7S298,242.09,298,242.09Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "311.795px 253.548px"
    },
    id: "el93caj27cprf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.1,238.65c-6,.28-10.24,1.6-14.54,5.63-3.17,3-10.72,23.62-7.75,37.55,2.29,10.72,15.9,16.26,26.29,11.32,8.2-3.9,9.19-19.43,9-26.48S276.1,238.65,276.1,238.65Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "271.126px 266.811px"
    },
    id: "ela6rp3fg2kxh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el99a2mdmm1no"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.1,238.65c-6,.28-10.24,1.6-14.54,5.63-3.17,3-10.72,23.62-7.75,37.55,2.29,10.72,15.9,16.26,26.29,11.32,8.2-3.9,9.19-19.43,9-26.48S276.1,238.65,276.1,238.65Z",
    style: {
      opacity: 0.3,
      transformOrigin: "271.126px 266.811px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.65,243.83s-1.62-2-5.39-.88a42.7,42.7,0,0,0-7,12.91s-1,0-.36-2.4,3.11-8.06,4.72-10.06,3.48-5.12,15-6.21c3.66-.34,14.38.42,17.63,1.46,5,1.62,4.05,4.32,4.05,4.32Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "276.529px 246.484px"
    },
    id: "el0zt2codh3d4j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7ahwzpdubf4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.65,243.83s-1.62-2-5.39-.88a42.7,42.7,0,0,0-7,12.91s-1,0-.36-2.4,3.11-8.06,4.72-10.06,3.48-5.12,15-6.21c3.66-.34,14.38.42,17.63,1.46,5,1.62,4.05,4.32,4.05,4.32Z",
    style: {
      opacity: 0.5,
      transformOrigin: "276.529px 246.484px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Kid--inject-277",
    className: "animable",
    style: {
      transformOrigin: "277.81px 290.395px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.38,236.9,303.44,235l-1.66-18.38c-.92-9.84-10.76-17.09-20.6-16.18h0A17.89,17.89,0,0,0,265,219.89l.29,3.69A14.76,14.76,0,0,0,281.38,236.9Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "284.183px 218.664px"
    },
    id: "elp5ysdqkg8qj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.94,378.3a4.19,4.19,0,0,1-.43-1.2,6.5,6.5,0,0,1,.58-4,9.42,9.42,0,0,0,1.13-4.71c-.18-1.7-.47-3.4-.73-5.09-1.17-7.64-3.24-20.27-3.32-23.28-.13-5.14-.13-7.67.83-11.71,0,0-3.57-11.66-5.08-18.31-2.4-10.61-4-18.83-3.17-28,.76-8.32-.14-11.84,4.71-17.42l.91-1.16s15.18,18.82,16.14,22A281.39,281.39,0,0,1,304.46,317c.26,8.06-.07,9.16-1,18.62-.76,7.79-1.55,16.41-2.49,25.58-.29,2.9-.52,6.38.39,9.19,1.9,5.81,7.22,9.25,11.71,13a3.66,3.66,0,0,1,1.67,2.45,2.46,2.46,0,0,1-1.39,2.08,9.46,9.46,0,0,1-3.06.69,13.71,13.71,0,0,1-3.38.28,17.38,17.38,0,0,1-5.8-1.13,15.43,15.43,0,0,1-4.09-3.26c-1.19-1.2-2.42-2.93-3.86-3.82C292,379.93,290.64,379.55,289.94,378.3Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "297.134px 326.161px"
    },
    id: "elzk5xy9uylm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.72,370.82a6.15,6.15,0,0,1,1.76-2.56,30.08,30.08,0,0,0,2.56-2.35,11.06,11.06,0,0,0,1.48-2.93c.26-.63.89-2.73,1.7-5.53,2.16-7.42,5.6-19.75,6.8-22.51,2-4.71,4-7.76,6.61-9.88,0,0,.6-12.85.83-19.66.36-10.07,1.53-20.93,6.38-27.95s8.77-9.1,15.53-12.11l1.31-.67s2.26,31.77.86,30.39c-1.79,8.2-4.17,17.84-6.14,26.27-1.78,7.61-2.25,9-7.53,17-4.3,6.54-9.42,14.35-14.13,22.27-2,3.44-4.32,8.06-4.78,12.13a22.29,22.29,0,0,0,4.09,15.52,3.08,3.08,0,0,1,.88,1.87c0,1-1.06,1.62-2,1.94a10.38,10.38,0,0,1-7.08-.19,10.1,10.1,0,0,1-6.32-9.62,12.05,12.05,0,0,0-1.31-6.76c-.66-1.16-1.59-2.27-1.65-3.6A3.14,3.14,0,0,1,241.72,370.82Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "264.783px 328.631px"
    },
    id: "el48s8cb5uu6j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.35,350a12.85,12.85,0,0,1-8.15-.5c-4.41-1.74-5.22-5-5.22-5l.28-1s-.31-.16-.67,1.31-4.69,15.92-5.06,17.49a27.21,27.21,0,0,1-2,4.58s.45,8.37,1.09,10.68,2.15,7.6,5.53,7.6,3.9-1.67,3.68-3.26A45.84,45.84,0,0,1,255,376a19.89,19.89,0,0,1,1.36-8.19c1.12-3,8.6-15.43,9.4-16.55s1.25-1.74,1.14-2.24Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "256.223px 364.327px"
    },
    id: "elia6kgvnvi2p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.21,243.29c-3.4.61-5,3.3-5.75,6.67-.37,1.68-.17,3.68.33,7.22s3.2,22.44,3.2,22.44l-2,12.12c5.47,5.95,25.51,7.66,37.46-1.07,0,0-.6-30.51-1.49-36.52-1.56-10.44-7.16-13.63-12.18-13.24l-12.18.71Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "283.86px 268.796px"
    },
    id: "elycvu9qxneg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.89,241.49s8.82,6.19,11.12,31.86c1.22-1.05,3.13-10,2.24-15.61-.81-5.15-3.69-13.48-7.3-15.65A8.26,8.26,0,0,0,291.89,241.49Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "298.684px 257.26px"
    },
    id: "elg7qanqjid5t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elsngvscf1vlb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.89,241.49s8.82,6.19,11.12,31.86c1.22-1.05,3.13-10,2.24-15.61-.81-5.15-3.69-13.48-7.3-15.65A8.26,8.26,0,0,0,291.89,241.49Z",
    style: {
      opacity: 0.4,
      transformOrigin: "298.684px 257.26px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.71,243.18s3.21,14.21-1.35,23.77c-1.68,3.51-5,6.69-6.54,7.35,0,0,0,4.39,2.43,6.32,0,0,6.06-3.84,8.79-9,2.44-4.64,5.46-14.15,1.9-29.42C275.94,242.17,272.58,242.14,270.71,243.18Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "270.196px 261.405px"
    },
    id: "ellqd5ms1cvq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.71,243.18s3.21,14.21-1.35,23.77c-1.68,3.51-5,6.69-6.54,7.35,0,0,0,4.39,2.43,6.32,0,0,6.06-3.84,8.79-9,2.44-4.64,5.46-14.15,1.9-29.42C275.94,242.17,272.58,242.14,270.71,243.18Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "270.196px 261.405px"
    },
    id: "elq5dcerij6xo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elg0ihdc7x344"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.71,243.18s3.21,14.21-1.35,23.77c-1.68,3.51-5,6.69-6.54,7.35,0,0,0,4.39,2.43,6.32,0,0,6.06-3.84,8.79-9,2.44-4.64,5.46-14.15,1.9-29.42C275.94,242.17,272.58,242.14,270.71,243.18Z",
    style: {
      opacity: 0.4,
      transformOrigin: "270.196px 261.405px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M244.68,208.24c.54-3.48,1.15-7,2-10.37a24.66,24.66,0,0,1,1.94-5.71,10,10,0,0,1,4.09-4.33,5.48,5.48,0,0,1,3.24-.65c1.11.16,3.34.79,3.83,1.8.66,1.35-.1,2.51-.79,3.85a36.54,36.54,0,0,0-1.79,4c-.09.25-1,2.21-.29,2a1.35,1.35,0,0,0,.41-.31,3.35,3.35,0,0,1,3-.85.83.83,0,0,1,.54.31c.19.33-.09.71-.34,1a34.59,34.59,0,0,0-3.13,3.91,12.12,12.12,0,0,0-2.19,3.87c-.21,1-.93,16.66-.5,20.58,0,0,9.86,11.48,15.58,16,3.77,13.53-4.27,18-5.27,15,0,0-19.79-20.85-22.07-25.75a10.25,10.25,0,0,1-.72-5.14c.34-4.85,1.15-9.67,1.84-14.48C244.21,211.35,244.44,209.79,244.68,208.24Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "256.715px 223.19px"
    },
    id: "elwdc71m2s8mi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.17,278.69l11.38,35.56s-3.23,11.88-29.77,11.89c-26.18,0-29.76-12.46-29.76-12.46l13-34.06C273.61,285.68,297.92,284,303.17,278.69Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "284.785px 302.415px"
    },
    id: "el19dy2gmmdj5i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.26,224.46c-.64.47-.79.69-1.36-.38-1.24-2.31-5.09-2.85-6.16.16s1.9,6.67,4.12,7.13c3.82.78,4.14-1.65,4.14-1.65l1.65,13.35a12,12,0,0,0,9.7,5.91c6.67.21,6-5.29,3.61-7.73l-.39-3.75a16,16,0,0,0,4.82-1c2-.79,3.5-2.21,4.55-5.53,1.41-4.48,1.17-9.19-1.09-17.83-2.62-10-15.18-9-21.18-4.33S275.26,224.46,275.26,224.46Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "284.166px 227.194px"
    },
    id: "elbg3uqktiyvo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.2,248.61s-8.79-1.85-12.69-6.67l-.4-3.24c-2.06.49-2.36,3.81-2.36,3.81a15.49,15.49,0,0,0,3.58,6.72c2.63,2.58,6.47.94,6.47.94s2,2.08,3,2.27S290.2,248.61,290.2,248.61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "282.475px 245.573px"
    },
    id: "el8476si1f6pq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.2,248.61c1.13-1.19,1.66-4.47.76-7.36,0-.22-.27-2.63-.27-2.63a2.61,2.61,0,0,1,1.39.46c.43.28,2.16,1.64,2.16,1.64a8.4,8.4,0,0,1,1.72,4.52,3.4,3.4,0,0,1-1.63,2.95,7.62,7.62,0,0,1,.07,2.61C294.12,251.51,290.2,248.61,290.2,248.61Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "293.08px 244.766px"
    },
    id: "elzws4evpxsm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.9,224.08l.37,3h0a2.89,2.89,0,0,0,2.58-3.09l-.47-6.3-4.06,1.17Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "274.589px 222.385px"
    },
    id: "els63h588lxa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,200.51h0a16.58,16.58,0,0,1,18.53,14.35l.27,2.13-8.05,1a7.55,7.55,0,0,1-8.24-5.53h0L289,219h0a6,6,0,0,1-6.62-4.68l-.23-1h0a7.09,7.09,0,0,1-6.2,7.38l-1.94.13L273,209.24Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "288.9px 210.604px"
    },
    id: "el9mdt0bc1q7t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,222.35a1.38,1.38,0,1,1-1.52-1.29A1.4,1.4,0,0,1,287,222.35Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "285.622px 222.434px"
    },
    id: "elbb1mymwhe4v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.79,218.38,282,220.29a1.75,1.75,0,0,1,.44-2.39A1.63,1.63,0,0,1,284.79,218.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "283.249px 218.941px"
    },
    id: "elcw236syc3ia",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.33,229.4l5.38,1.41a2.73,2.73,0,0,1-3.34,2.08A2.91,2.91,0,0,1,286.33,229.4Z",
    style: {
      fill: "rgb(177, 102, 104)",
      transformOrigin: "288.979px 231.187px"
    },
    id: "elu2isxdk7j9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.43,231.08a2.17,2.17,0,0,1,1.15-.36,2.29,2.29,0,0,1,2.34,2.11,2.63,2.63,0,0,1-1.55.06A2.84,2.84,0,0,1,286.43,231.08Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "288.175px 231.849px"
    },
    id: "elxy5qyqe9mx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.84,216.78l-3.27-.83a1.62,1.62,0,0,1,2-1.25A1.77,1.77,0,0,1,298.84,216.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "297.225px 215.713px"
    },
    id: "elibz4mvxf7a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.46,221.05a1.38,1.38,0,1,1-1.52-1.29A1.41,1.41,0,0,1,298.46,221.05Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "297.082px 221.134px"
    },
    id: "elal3x4dtq47c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.98 220.43 292.13 227.72 295.83 226.02 290.98 220.43",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "293.405px 224.075px"
    },
    id: "elajmdt1tk1wf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.57,237.5s-6.61,0-9.77-1.61a8.32,8.32,0,0,1-3.25-2.61,8.24,8.24,0,0,0,2,3.26c3.29,3.17,11.16,2.56,11.16,2.56Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "284.13px 236.214px"
    },
    id: "elebrgl08wz99",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,365.91s-.43.74-.51,1c-.15.39.52,2.42,1.28,4.94s1.3,9,3.44,10.85,6,.91,5.58-.77a43.5,43.5,0,0,0,2.68,4.39c1,1.27,2.75,3.34,1.83,5.17a3.94,3.94,0,0,1-2.29,1.76,11.28,11.28,0,0,1-9.25-1.53,9.55,9.55,0,0,1-4.66-7.64c-.31-2.45.23-5.05-.69-6.84s-2.06-3.71-2.52-4.7a5.43,5.43,0,0,1,1.14-3.67A12.18,12.18,0,0,1,246,365.91Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "250.72px 379.776px"
    },
    id: "eld878rjmuvia",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M302.76,342.93s.53,0,.33,1.83c-.15,1.46-1.56,13.34-1.8,17.12s-.5,7.76,1.15,10.61,6.17,7.28,6.17,7.28-.5,3.64-6.95,2.29c-4.09-.86-11.57-8.93-11.57-8.93s.65-2.17.89-3.44-1.29-9.58-2-13.69-1.49-9.95-1.69-11.39c-.29-2,.13-1.95.13-1.95l.14,1.11s1,1.81,7.52,2c5.94.18,7.61-2,7.61-2Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "297.899px 362.51px"
    },
    id: "eldqxiiwje07r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,368.77v.92a4.24,4.24,0,0,0,1.71,4.24c2.33,1.6,5.24,4.55,7.11,6,2.69,2.07,6.61,1.92,8.05.6a1.11,1.11,0,0,0,.4-1.12s1.5,1,2.79,1.9,4.43,2.57,4.12,4.6-2.21,3.13-4.79,3.56a15.28,15.28,0,0,1-10.11-2c-2.37-1.54-4.39-4.57-5.32-5.4s-3.87-2-4.9-2.64c-.82-.52-1.36-2.76-.87-4.53a31.1,31.1,0,0,0,1-4.49C290.27,369.49,290.34,368.84,291,368.77Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "302.102px 379.204px"
    },
    id: "el4223iw9vr3h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.71,243.18,259,232.24c.09,3.64-4.86,10.59-7.66,11.17l14.16,19s1.23.36,3-1.35a12.82,12.82,0,0,0,3.24-7.52C272.21,249.94,270.71,243.18,270.71,243.18Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "261.586px 247.341px"
    },
    id: "elrcf4ay8yzf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.22,259.84c3.87,3.39,7.39,6.65,9.13,9.65,2.51,4.32.87,7.42-2.52,8a27,27,0,0,1-7.18.22,81.77,81.77,0,0,1-16.07-3.11c-2.86-.76-5-1.13-5.57-1.28-1.85-.48-3.93-.1-5.19-6.21-.65-3.15-1.1-7.08,3.15-7.56l.21.93c.35.59,3.59.17,4.3-.58a25.68,25.68,0,0,0-.5-3.66c.9-.41,2,.61,2.62,2.59a14.38,14.38,0,0,0,1.56,4c1.1,1.49,4.57,2,8.72,2.2A24.85,24.85,0,0,0,325.22,259.84Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "316.484px 267.001px"
    },
    id: "elip2vbw4bg8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.88,265.1c3.32.15,5-.45,8.83.38a10.93,10.93,0,0,0-6.06-1.91A30.2,30.2,0,0,1,317.88,265.1Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "322.295px 264.525px"
    },
    id: "el58k4wf015g",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters-1--inject-277",
    className: "animable",
    style: {
      transformOrigin: "143.796px 228.694px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--mom-and-child--inject-277",
    className: "animable",
    style: {
      transformOrigin: "143.796px 228.694px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-277",
    className: "animable",
    style: {
      transformOrigin: "124.79px 220.627px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.87,212.32l11,12.82,16.28-10.68,4.26,9a147.33,147.33,0,0,1-15.64,12.29c-2.51,1.61-7.52,5.64-11,2.15-3.29-3.3-7.79-8.74-7.79-8.74Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "131.195px 225.801px"
    },
    id: "elj00qokq32x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.14,214.46,139,217.84a8.6,8.6,0,0,0,7.83,7l1.59-1.41Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "143.71px 219.65px"
    },
    id: "eln2pna3vdawm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.16,202c6.89-.45,12.36,4.79,16.34,9.48s9.16,12.08,9.16,12.08-2.78,8.12-10.12,10.58l-12.64-15Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "113.91px 218.056px"
    },
    id: "elzytafs2fcvi",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mom--inject-277",
    className: "animable",
    style: {
      transformOrigin: "179.141px 228.694px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-277",
    className: "animable",
    style: {
      transformOrigin: "179.141px 228.694px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.88,342.41c.06,2.11,2,7.4,2,7.4s1.36,1.63,4.75,2.05L190,344Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "187.255px 347.135px"
    },
    id: "elye6m8437wsf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.66 351.86 196.78 347.83 196.78 341.42 190.27 347.29 190.66 351.86",
    id: "elxrkitv7i8h",
    className: "animable",
    style: {
      transformOrigin: "193.525px 346.64px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.42,332.15l-.3-1.31c1,.2,4.5,7.3,8.59,11.6,3.73,3.94,9.34,5.17,11.48,6.74,2.86,2.1-.35,6.69-7.4,7.07-3.5.19-9.08-.57-11-2.43s-3.54-5.84-5.09-7.18-4.71-2.51-5.78-4.23c-.58-.94-.67-3.28-.61-5.28.07-1.84.12-3.87.75-3.84,0,.21.29,1.1.29,1.1.31.86,1.57,1.64,5.17.83C191.1,334.86,193.91,333.92,193.42,332.15Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "198.763px 343.559px"
    },
    id: "elistyn94ktk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.11,309c-1,1.66-1.69,12.58-1.69,12.58A31.31,31.31,0,0,0,121,326l3.6-10.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "120.51px 317.5px"
    },
    id: "elflliivqzyr4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.03 326.03 129.53 323.03 132.01 315.93 123.21 319.5 121.03 326.03",
    id: "ela3afysc0h9d",
    className: "animable",
    style: {
      transformOrigin: "126.52px 320.98px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.29,302.36c-.61-.55-1.39.62-3,2.38a22.65,22.65,0,0,0-3.14,4.06c-.89,1.81,1.73,5.78,3.43,7.94s2.16,4.25,2.52,7.56c.44,4,0,6.54,5.34,9.55,4.27,2.4,12.34,2,13.92.15,2.68-3.16-4.8-6.23-6.6-11.88-2.49-7.79-2.84-9.1-3.23-14.69Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "130.952px 318.872px"
    },
    id: "el7nk57u4dhh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.76,194.73c-3.61,2.52-5.69,5.67-22.45,4l-2,48.31s-13.38,9.32-17.15,15.4-21.46,36.32-21.46,36.32h0l-2.53,3.72c-1.58,2.31-.78,4.16,1.53,5.73s5,2.31,6.77.37l2.18-2.38s43.22-41.94,44.7-44.46,4.77-8.78,7.68-21.47C190.79,224,190.42,212.54,189.76,194.73Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "156.765px 252.237px"
    },
    id: "elnek1ra9scb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.45,202.64a69.51,69.51,0,0,0,21.31-7.91,153.23,153.23,0,0,1,1.59,23.11c0,4.82-1.17,15-1.17,15C187.93,246.24,184,261,179.81,265.3s-27.91,24.12-27.91,24.12-9.72-3.2-14-12c0,0,8.05-13.49,13.58-20.17,5.73-6.94,15.5-11.14,15.5-11.14Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "164.627px 242.075px"
    },
    id: "elvo86shjredo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.61,265.51l-.74-12.68-4.38-23.72-6.77-5L167,246.15a52.87,52.87,0,0,0-10.92,6.68h0L163.34,266s-.89,9,.57,13.31C170.29,273.89,177.29,267.86,179.61,265.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "167.845px 251.71px"
    },
    id: "elzgw3tcuv9gn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.87,333.15l-.15-1c-1.76-8.76-6.08-57.53-7.63-70.65-1.68-14.2-8.21-48.33-8.21-48.33s7.15-11.93,11.88-18.46c-4.44,6.43-30.55,6.4-33.41-4.67-1.6,4.67-8.57,10.11-7.57,24.76,1.28,18.67,18.16,50,18.16,50-.22,2.54-1.29,13.2,1.13,22.64,3.82,14.91,14.35,40.84,15.57,44.44l.83,3.06C186.4,336.78,193,335.73,193.87,333.15Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "171.276px 262.954px"
    },
    id: "elehkxpeurdak",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.34,235.5l-3-20.68a45.52,45.52,0,0,0,9.42-20.09s-6.46,4-16.34,2.7a36.18,36.18,0,0,1-17.07-7.37,54.79,54.79,0,0,0-4.77,8.09c-1.5,2.9-3.75,10.24-3.4,15.66.8,12.45,6.27,25.22,6.27,25.22,3.12,9.47,11.25,26.42,11.25,26.42s-.86,13.11,1.36,22.19a110.75,110.75,0,0,0,7.14,19.07S185,309,191.35,304.19l-4.63-44.59C185.42,247.08,183.34,235.5,183.34,235.5Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "169.747px 248.657px"
    },
    id: "eln3cygz9nwz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.65,161.47l-.21-.1c-13.14-6.19-18.42-20.77-17.77-34.6A36.34,36.34,0,0,1,154.35,114a21.61,21.61,0,0,1,8.28-9.94,20.68,20.68,0,0,1,9.5-2.86c3.05-.2,7-.15,9.85,1a3.42,3.42,0,0,0,2.82.1,9.63,9.63,0,0,1,3.12-.19,10.85,10.85,0,0,1,7.16,4.21c2.42,3,2.71,7.44,1.87,11.06-.39,1.66-1.85,3.49-1.75,5.08.14,2.31,2.13,4.74,3.46,6.5,1.6,2.1,3.32,4.19,4.14,6.7s.51,5.59-1.48,7.33a11.74,11.74,0,0,1,4.1,5.38,6.12,6.12,0,0,1-1.38,6.34,23.38,23.38,0,0,0-2.18,1.77c-.86,1-1.09,2.37-1.62,3.57-1.21,2.73-4.05,4.47-7,5.1a26.78,26.78,0,0,1-8.93-.08C179.34,164.43,174.25,163.61,169.65,161.47Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "178.698px 133.298px"
    },
    id: "el3k1o513awp2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.19,158a5.37,5.37,0,0,0,.32-1.67,8.05,8.05,0,0,0-.69-1.8,3.93,3.93,0,0,0-.75-1.36,2.59,2.59,0,0,0-2.44-.59,5.4,5.4,0,0,0-2.24,1.32c-1.24,1.1-2.26,2.45-3.45,3.61a9.79,9.79,0,0,1-2.09,1.59,6.29,6.29,0,0,1-1.16.51c-.27.09-.92.36-1,0a4.31,4.31,0,0,1,.23-1.2c.1-.64.18-1.28.22-1.92.06-1.1.11-2.69-.77-3.51-1.48-1.38-1.11,1.79-3.41,4.79s-2.65,7.51-4.41,9.54v0L209,176.47s-7.7-14.29-12.27-22.22c-4.42-7.68-10.66-8-16.23-7.6-2.66,8.79,6.22,21.61,6.22,21.61s13.45,19.05,16,21.84c3,3.36,6.89,3.48,10.05.48a58.94,58.94,0,0,0,5.74-6.58,90.17,90.17,0,0,1,7.35-8.84,19.57,19.57,0,0,1,4.07-3.38,53.14,53.14,0,0,0,5.45-3.44,24.68,24.68,0,0,0,3.77-3.38,15,15,0,0,0,1.6-2,10.33,10.33,0,0,0,.7-1.8,4.71,4.71,0,0,0,.41-1.64,1.73,1.73,0,0,0-.69-1.48Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "210.933px 169.635px"
    },
    id: "el9kw0j1xc7i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.15,146.51l-8.94.49a11.11,11.11,0,0,0-2,1.17c-2.79,2.25-3,6.65-3.47,9.9-.71,4.88,1.58,10.35,2.83,15a29.17,29.17,0,0,1,.1,16.28,62.74,62.74,0,0,1-2.86,7c-.46,1.13-1.47,2.67-1.58,3.91,7.45,7.6,29.76,12.81,41.07,3.51.09-5.4,0-16.74,0-17,.23-4.89,0-9.84,0-9.84,6.16-6,3.68-12.54,1.52-16.87-4.32-8.65-9.79-13.74-13.6-13.55Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "172.71px 177.628px"
    },
    id: "elaliioreqkm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.91,180.36c11.3-23,13.37-29.78,19.85-32.46a19.18,19.18,0,0,1,6.45-.9c1.59,2.91,4.46,14.15-2.2,20.63,0,0-9.3,12.73-12.72,18.78.69,6.26,1.16,13.76,3.17,18.1a3.62,3.62,0,0,0,2.1,1.88c2.5.9,3.11,2.27,5.07,3.63,1.53,1.06,2.74,1.17,2.61,1.63a2.54,2.54,0,0,1-2.78,1.5,11.51,11.51,0,0,1-3-.88,19.15,19.15,0,0,0,4,4.41c3.7,3.08,4.12,5.32-2.45,6.63-4.12.82-7.7-.9-11.82-8.71a62.56,62.56,0,0,1-4.05-8.89,129.86,129.86,0,0,1-4.6-17.76C130,184.49,130.21,181.77,130.91,180.36Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "144.722px 185.243px"
    },
    id: "elfueooj008pa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.59,124c1.87-2.1,5.11-1.72,6.7,1,0,0,2.74-.27,9.15-3,5.26-2.22,11.23-6.76,11.93-11.82,2.19,3,3.95,9.94,3.93,18.1,0,10.09-3.44,11.92-5.08,12.64s-4.83,1-7.91.48l-.06,5.07s6.39,4.66.54,5.5c-7.32,1-13.08-5.41-13.08-5.41l-.85-13.18a4.42,4.42,0,0,1-5-.85A6.74,6.74,0,0,1,158.59,124Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "173.75px 131.128px"
    },
    id: "el6t0bquhyabc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.69,146.3l-5.12.57s4.64,7.21,10.69,8.21,7.53-3.05,7.53-3.05a28.16,28.16,0,0,1-8.25-2.3A15.45,15.45,0,0,1,164.69,146.3Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "168.68px 150.769px"
    },
    id: "elcvz8fka5k4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.25,146.11v.42c.83,1,3.46,4.32.54,5.5,0,0,4.18,2.3,4.93-.45s-2.73-5.07-2.73-5.07Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "180.038px 149.52px"
    },
    id: "elgsdjnmlzut",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.38,119.36l3.33,1.34a1.72,1.72,0,0,0-.93-2.32A1.88,1.88,0,0,0,185.38,119.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "187.124px 119.475px"
    },
    id: "el2up8yriok15",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.78,125.23a1.47,1.47,0,1,1-1.68-1.31A1.5,1.5,0,0,1,177.78,125.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "176.317px 125.376px"
    },
    id: "el50gtn7g9c15",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.32,124.19a1.38,1.38,0,1,1-1.57-1.22A1.41,1.41,0,0,1,188.32,124.19Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "186.948px 124.338px"
    },
    id: "eldzjbwevlzfc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "181.43 123.31 181.84 131.65 186.74 130.41 181.43 123.31",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "184.085px 127.48px"
    },
    id: "eltteec2r8le",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.59,133.89l3.65.81a1.84,1.84,0,0,1-2.19,1.48A2,2,0,0,1,177.59,133.89Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "179.399px 135.055px"
    },
    id: "el637jy3phvm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.31,141.46c-3-.38-9-2.1-10-4.5a6.22,6.22,0,0,0,2.14,3.06c1.82,1.55,7.84,3.31,7.84,3.31Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "172.31px 140.145px"
    },
    id: "eldk9uuj3w28r",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M222.49,192.58l-3.09-1.78a23.85,23.85,0,0,0-.8-6.92l2.18-2.82A51.6,51.6,0,0,1,222.49,192.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "220.545px 186.82px"
    },
    id: "elrc05urnkmg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.61,193.57l-.12-1-.1.06,0-.06-3-1.78c-.4,1.15-1,2.71-1.49,4.45-6.36,3.68-17.06,9.82-17.06,9.82l3.29,24.85,21.44-12.45h0a1.89,1.89,0,0,0,.89-1.11C227.38,213.79,223.62,197.73,222.61,193.57Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "213.722px 210.35px"
    },
    id: "elr695tiey53i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.49 192.58 200.85 205.07 197.76 203.29 219.4 190.8 222.49 192.58",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "210.125px 197.935px"
    },
    id: "elak69d8ez4dp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elwjky0pmfmk"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "222.49 192.58 200.85 205.07 197.76 203.29 219.4 190.8 222.49 192.58",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.1,
      transformOrigin: "210.125px 197.935px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elzgb0obn9nsp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.11,210.43s-.12.57,2,1,10.84.35,12-.34,4.24-4.48,5.64-7a34.38,34.38,0,0,0,2.19-4.87Z",
    style: {
      opacity: 0.2,
      transformOrigin: "213.024px 205.457px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.76,203.29c-1.8,5.2-5.23,18.57-4.71,20.57s3.15,3.52,4.71,4.41,6.15,3.55,7.19.59-4.1-23.79-4.1-23.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "199.043px 216.755px"
    },
    id: "el2jjh7ratd6i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.85,205.07c0,.31.47,4.12,1.26,5.36s11.42.5,13.24,0,8.34-9.78,8.57-11.23-1.43-6.62-1.43-6.62Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "212.396px 201.845px"
    },
    id: "elbbxtugcx9lp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.94,208.5c.06.46.4.61.78.34a1.64,1.64,0,0,0,.58-1.34c-.05-.47-.4-.62-.77-.34A1.62,1.62,0,0,0,214.94,208.5Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "215.62px 207.997px"
    },
    id: "elurh8yampfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.17,173.74c-11.35,2-14.41,29.55-14.41,29.55l3.09,1.78c.56-16.94,7.44-28.44,10.2-30.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "204.965px 189.405px"
    },
    id: "elyllc2kyzc1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.09,209.67c-3.59.9-4.67,4.67-1.73,6.7s8,.2,8,.2l.88.75c.66-.57,1.14-2-.15-3.91C152.59,211.27,150.3,208.85,147.09,209.67Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "149.283px 213.417px"
    },
    id: "el7au8ghwpa5t",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--kid-1--inject-277",
    className: "animable",
    style: {
      transformOrigin: "83.1703px 256.924px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.35,198.38c-6.08.25-10.39,1.63-14.8,6-3.23,3.19-11.1,25.55-8.24,40.71,2.2,11.66,15.93,17.82,26.51,12.55,8.35-4.15,9.52-21,9.36-28.67S74.35,198.38,74.35,198.38Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "68.9444px 228.961px"
    },
    id: "el7qu0d9zvcoq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el0g2932g2x94f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.35,198.38c-6.08.25-10.39,1.63-14.8,6-3.23,3.19-11.1,25.55-8.24,40.71,2.2,11.66,15.93,17.82,26.51,12.55,8.35-4.15,9.52-21,9.36-28.67S74.35,198.38,74.35,198.38Z",
    style: {
      opacity: 0.3,
      transformOrigin: "68.9444px 228.961px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.75,203.93s-1.62-2.17-5.46-1c0,0-4.07,4.81-7.27,13.94,0,0-1,0-.33-2.6s3.24-8.73,4.88-10.89,3.59-5.52,15.24-6.59c3.71-.33,14.57.6,17.85,1.77,5.07,1.8,4,4.73,4,4.73Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "74.6066px 206.796px"
    },
    id: "elmcklsshap9c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqk6twylrymp"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.75,203.93s-1.62-2.17-5.46-1c0,0-4.07,4.81-7.27,13.94,0,0-1,0-.33-2.6s3.24-8.73,4.88-10.89,3.59-5.52,15.24-6.59c3.71-.33,14.57.6,17.85,1.77,5.07,1.8,4,4.73,4,4.73Z",
    style: {
      opacity: 0.5,
      transformOrigin: "74.6066px 206.796px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--kid--inject-277",
    className: "animable",
    style: {
      transformOrigin: "83.1703px 256.924px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.1,347.09c-4.45-3.74-10.94-8.43-12.12-14.43,0,0,.65-4.85.91-7.76.87-9.88,1.24-17.84,2.08-25.63,1-9.45,1.36-10.54,1.18-18.6-.06-2.73-.19-5.64-.36-8.63-.16-9.44-.76-18.59-.74-25.63,0,0-13.06.25-23.4.9-11.16,1.37-15,3.88-14.63,5.31a97.93,97.93,0,0,0-1.68,15.2c-.3,6.81-1.42,22.83-1.42,22.83-2.6,2.11-4.61,5.13-6.7,9.82-1.23,2.76-4.4,11.86-6.63,19.26-.84,2.79-1.5,4.89-1.76,5.51a11.05,11.05,0,0,1-1.5,2.92,31.74,31.74,0,0,1-2.59,2.32A6,6,0,0,0,47,333a3.14,3.14,0,0,0-.16,1.11c.05,1.33,1,2.45,1.61,3.62a12,12,0,0,1,1.25,6.76,10.1,10.1,0,0,0,6.22,9.69,10.38,10.38,0,0,0,7.08.26c.94-.31,2-.93,2-1.92a3.1,3.1,0,0,0-.86-1.88,22.3,22.3,0,0,1-3.94-15.56C60.68,331,63,326.44,65.08,323c4.78-7.87,10-15.63,14.35-22.13,5.35-8,5.84-9.37,7.69-17,.88-3.6,1.84-7.43,2.79-11.26,1.28,5.91,3.17,16.38,3.59,18.7,0,.34-.07.78-.11,1.28-.81,3.57-.83,6.1-.75,10.88,0,3,2,15.66,3.09,23.31.24,1.7.51,3.4.67,5.1a9.4,9.4,0,0,1-1.17,4.7,6.42,6.42,0,0,0-.62,4,4.62,4.62,0,0,0,.41,1.21c.69,1.25,2.09,1.65,3.21,2.37,1.42.91,2.64,2.64,3.82,3.86a15.45,15.45,0,0,0,4,3.3,17.85,17.85,0,0,0,5.79,1.19,13.81,13.81,0,0,0,3.39-.25,9.36,9.36,0,0,0,3-.66,2.46,2.46,0,0,0,1.42-2.07A3.67,3.67,0,0,0,118.1,347.09Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "83.244px 300.675px"
    },
    id: "elf9l1ek7k6fc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,332.66c-.49.74-3.13,1.11-4.27,1.56s-1,3-1,3c-1,0-1.14-.78-1.49-2.11-.59-2.25-2.26-2.25-2.81-2.53l0-.69s-.57-.17-.69.91a26.2,26.2,0,0,1-1,4.27c-.33,1-.85,4.48-.11,5.54A6.12,6.12,0,0,0,97,344.39a13.69,13.69,0,0,1,4.67,4.08c1,1.43,3.87,4.76,10.29,4.82s8.2-2.25,8.2-2.25a3.49,3.49,0,0,0-1.09-4.61c-2.65-2-4.23-2.31-7-5.41A68.09,68.09,0,0,1,106,332.66Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "107.432px 342.586px"
    },
    id: "el5rx5x3e7ymy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.51,333.29A8.09,8.09,0,0,1,56,331.53c-2.12-1.47-2.93,2.76-2.93,2.76-.66-.49-1-1-.53-3,.43-1.83.43-2.91-.61-3.95l.47-1s-.57-1-1.84,1.36-4.39,3.2-4.83,6.74a11.26,11.26,0,0,0,1.49,3.66,9.15,9.15,0,0,1,1.66,6.24c-.23,2.69.94,7.26,4.06,9.32A12.16,12.16,0,0,0,64.25,355a3.39,3.39,0,0,0,.45-4.88c-2.1-3-3-4.39-3.68-7S60.51,333.29,60.51,333.29Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "55.6311px 340.975px"
    },
    id: "el3xy1yfiku5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.53,246s-.87,10.13-1.18,16.08-2.18,28.54-2.18,28.54c-7.51,6.79-10.84,21-13.83,31.5,0,0,4,5.68,10.49,4.25-.08-.42,19-28.35,21.46-34.36,2.2-5.41,4.59-17.15,4.59-17.15s2.72,13.4,2.31,15.92c-1.68,10.17,2.13,27.28,2.9,34.31,0,0,.77,2,5.82,2.08,5.22.07,6.2-1.72,6.2-1.72s3.19-33.81,3.59-40.18-.86-30.58-1.65-38.89Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "82.0583px 286.586px"
    },
    id: "el6rczj4i7523",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.88,274.89,91,268.55s8.49-.61,12.25-4.81c0,0-1.3,5.55-10.18,6.33l-1.19,6.13.3,12.37C91.53,284,90.7,279.92,89.88,274.89Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "96.565px 276.155px"
    },
    id: "elwkce0a0t2ej",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.22,202.56c-4.4.8-5.69,3.5-6.18,7.2a27.3,27.3,0,0,0,.94,10l2.39,14.91.46,18c5.47,6.06,27.71,8.2,39.85-.48,0,0-1-31.05-1.81-37.13-1.47-10.55-5.14-13.77-10.21-13.43l-15.32.45Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "87.8032px 229.79px"
    },
    id: "elqnyywetgg0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8,201.68c2.52,1.75,14.26,12.75,13.52,40,0,0,1.38-8.49,2-14.15S109.07,205.8,101.6,202A8.64,8.64,0,0,0,95.8,201.68Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "103.601px 221.502px"
    },
    id: "el72eq5pcr44m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eldzqp490kwak"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.8,201.68c2.52,1.75,14.26,12.75,13.52,40,0,0,1.38-8.49,2-14.15S109.07,205.8,101.6,202A8.64,8.64,0,0,0,95.8,201.68Z",
    style: {
      opacity: 0.4,
      transformOrigin: "103.601px 221.502px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.66,202.21s6.2,4.42,6.61,14.57c1,25.67-15.88,32.37-15.88,32.37-1.6-3.25-.56-6.37.82-9.46a29.17,29.17,0,0,0,8.17-21.17c-.35-9.35-4.94-14.63-7.27-15.37A13.46,13.46,0,0,1,77.66,202.21Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "75.9469px 225.591px"
    },
    id: "elk9i0ol9na6n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elktoopubafq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.66,202.21s6.2,4.42,6.61,14.57c1,25.67-15.88,32.37-15.88,32.37-1.6-3.25-.56-6.37.82-9.46a29.17,29.17,0,0,0,8.17-21.17c-.35-9.35-4.94-14.63-7.27-15.37A13.46,13.46,0,0,1,77.66,202.21Z",
    style: {
      opacity: 0.4,
      transformOrigin: "75.9469px 225.591px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elh30thsj3npr"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 98.24,
    cy: 174.74,
    rx: 11.2,
    ry: 10.82,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.24px 174.74px",
      transform: "rotate(-89.43deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76,182.85s1.78,8.8,2.51,10.25A4,4,0,0,0,80.75,195l-.07-6.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "78.375px 188.925px"
    },
    id: "eljpn26edz3pl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.43,170.3a4.33,4.33,0,0,0-3.6,1.22c-1.55,1.56-.74,6.49,1.13,11.33l3.51.44Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.7414px 176.777px"
    },
    id: "elq1caljks92",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.53,183.3c-.71.42-1.7-1-2.56-1.87s-3.7-2.19-5.14.78S74,189.29,76.24,190c3.84,1.24,4.44-1.22,4.44-1.22l.16,13.9a12.39,12.39,0,0,0,9.29,7.2c6.82,1,6.82-4.74,4.6-7.52l0-3.9a16.65,16.65,0,0,0,5.07-.46c2.18-.57,3.84-1.86,5.31-5.15,2-4.44,2.27-9.3.94-18.45-1.54-10.59-14.55-11-21.27-6.89S80.53,183.3,80.53,183.3Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "89.6434px 187.543px"
    },
    id: "el45p11mzzh29",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.93,176.29c-.65,3-1.22,8.19-2.41,8.2-.36,0-1.68-2.25-2.55-3.06-.39-.36-.39-1.13-.42-1.62a39,39,0,0,1,.09-5.51c.17-2-.12-4.14.52-6a6.5,6.5,0,0,1,2.91-3.38c2.94-1.72,6.8-1.49,10.08-2.11a33.32,33.32,0,0,0,11-3.89l1-.6a1.6,1.6,0,0,1,1-.29,1,1,0,0,1,.69.54,2.56,2.56,0,0,1,.24.87,9.13,9.13,0,0,1,0,2.76,4.61,4.61,0,0,1-.65,2.32l2.4-1.46a.76.76,0,0,1,.53-.18c.33.06.45.46.47.79a8.2,8.2,0,0,1-3.63,7,14.94,14.94,0,0,1-7.79,2.45c-2.75.17-5.51-.1-8.27-.18-1,0-2.6-.15-3.51.4A4.24,4.24,0,0,0,82.93,176.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "92.6623px 171.259px"
    },
    id: "elgm0k3mlopwo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.43,171.08l-4.25-2.33a2.35,2.35,0,0,1,3.24-1A2.54,2.54,0,0,1,78.43,171.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "76.4371px 169.267px"
    },
    id: "elnyj5xtjokio",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.76,198.48s-6.79-.77-9.86-2.79a8.58,8.58,0,0,1-3-3.05,8.44,8.44,0,0,0,1.71,3.58c3,3.64,11.16,4.41,11.16,4.41Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "88.335px 196.635px"
    },
    id: "el7n5s6y5eswc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.52,181.86a1.43,1.43,0,1,1-1.41-1.5A1.45,1.45,0,0,1,92.52,181.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "91.0913px 181.79px"
    },
    id: "elr485g7ud0y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.71,177.53l-3.06,1.65a1.82,1.82,0,0,1,.74-2.41A1.7,1.7,0,0,1,90.71,177.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "89.0825px 177.877px"
    },
    id: "elorz8vwskxn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.64,189.53l5.6,2.17a3,3,0,0,1-3.84,1.82A3.15,3.15,0,0,1,91.64,189.53Z",
    style: {
      fill: "rgb(154, 74, 77)",
      transformOrigin: "94.345px 191.613px"
    },
    id: "el1r96k4jryjzi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.78,178.46,102,176.3a1.68,1.68,0,0,1,2.41-.34A1.83,1.83,0,0,1,104.78,178.46Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.558px 177.028px"
    },
    id: "el9khyk2uz1tj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,181.31a1.45,1.45,0,0,1-1.44,1.47,1.49,1.49,0,0,1,0-3A1.45,1.45,0,0,1,104,181.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "102.531px 181.28px"
    },
    id: "el5v7t7uvnpb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.45 180.32 96.8 187.95 100.79 186.63 96.45 180.32",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "98.62px 184.135px"
    },
    id: "el3fymag6wgtu",
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.67,210.13s-8.53-2.85-11.84-8.1l0-3.22c-2.11.24-3.16,3.54-3.16,3.54s.19,4.25,2.72,7,6.77,1.74,6.77,1.74,1.76,2.3,2.7,2.6S92.67,210.13,92.67,210.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "85.17px 206.258px"
    },
    id: "el0sfm7blbwrx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.67,210.13c1.26-1,2.61-4.78,2.06-7.75,0-.22,0-2.14,0-2.14a2.14,2.14,0,0,1,1.33.54,17.46,17.46,0,0,1,1.52,2,32.84,32.84,0,0,1,1.18,4.7,3,3,0,0,1-2,2.74,7.41,7.41,0,0,1-.24,2.6C96.23,213.47,92.67,210.13,92.67,210.13Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "95.715px 206.572px"
    },
    id: "elrxjp7hv8btn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.47,249.45c2.16-.73,3.74-1.84,8-5.4a71.24,71.24,0,0,0,9.66-9.78,20.66,20.66,0,0,1,1.57-1.67,16.17,16.17,0,0,0,2.65-2.93c1.72-2.56,1.76-4.24,1.95-7.32S86.41,215,85.08,212c-.19-.45-1.32-.71-1.64-.62.18.68.3,1.37.43,2a15.82,15.82,0,0,1-2.57,4.26c-1.57,1.81-3.27,2.8-3.44,2.41s.38-1.58.21-3.53-.7-2.65-1.29-2.8c-.94-.25-1,.77-1.36,2.32C74.93,218,74.13,219,74,221.7c-.11,2.39,0,3.36-1.11,4.72A39.72,39.72,0,0,1,69,229.55s1.43-4.4,2.85-8.79c2.77-8.6,1.68-16.29-1.71-17.61-4.85.22-7.83,2.16-10.06,9.17-2.37,7.46-3.18,10.63-5.12,25.26C53.49,248.43,58.88,250.66,62.47,249.45Z",
    style: {
      fill: "rgb(255, 168, 167)",
      transformOrigin: "70.5442px 226.448px"
    },
    id: "elzri815y0x2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,229.55c-3.07,2.24-9.79,5.46-10.69,9.08,0,0,.15-2.88,4.21-6.3a51,51,0,0,1,7.26-5.17Z",
    style: {
      fill: "rgb(242, 143, 143)",
      transformOrigin: "64.045px 232.895px"
    },
    id: "elimm4040nv4k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.11,203.15c-1.67-.38-4.48.19-6.93,2.37s-3.7,6.46-4.89,10.31-3.13,14-3.13,14a35.68,35.68,0,0,0,10.27,2s2.74-1.74,4.09-2.69c0,0,2.77-8.84,3.56-11.09S75,204.79,70.11,203.15Z",
    style: {
      fill: "rgb(240, 240, 240)",
      transformOrigin: "64.4724px 217.435px"
    },
    id: "elsqpjludc98s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elei51nwjrwb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93,191.23a2.36,2.36,0,0,0-1.35.43,3,3,0,0,0,1.77,1.86,2.85,2.85,0,0,0,1.93,0A2.37,2.37,0,0,0,93,191.23Z",
    style: {
      fill: "rgb(242, 143, 143)",
      opacity: 0.6,
      transformOrigin: "93.5px 192.459px"
    },
    className: "animable"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-277",
    className: "animable",
    style: {
      transformOrigin: "410.47px 61.9602px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-277",
    className: "animable",
    style: {
      transformOrigin: "410.47px 61.9602px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-277",
    className: "animable",
    style: {
      transformOrigin: "410.47px 61.9602px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.59,91.76,410.26,83l6.35-5V71.31L428.12,78,418,78.76l-4.95,8.57a.73.73,0,0,1-.33.3h0Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "416.855px 81.535px"
    },
    id: "ell29s1ap4gy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el77su3ydts6j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405.59,91.76,410.26,83,406.5,72.12V65.47L418,72.12v6.64l-4.95,8.57a.73.73,0,0,1-.33.3h0Z",
    style: {
      opacity: 0.2,
      transformOrigin: "411.795px 78.615px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M378.05,37.78a7.73,7.73,0,0,1,3.45-6l2.8-1.63a7.48,7.48,0,0,1,6.89,0L439.45,58.2a7.75,7.75,0,0,1,3.44,6v21.9a7.73,7.73,0,0,1-3.44,6l-2.81,1.64a7.54,7.54,0,0,1-6.89,0l-18.93-11-4.93,8.64a.73.73,0,0,1-1.33-.13l-5.21-15.21L381.5,65.72a7.72,7.72,0,0,1-3.45-6Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "410.47px 61.9412px"
    },
    id: "elankguwmblid",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ell6bxph3bwe"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.49,94.17a7.68,7.68,0,0,0,6.15-.35l2.81-1.64a7.72,7.72,0,0,0,3.44-6V64.24a7.34,7.34,0,0,0-1.15-3.66l-9.57,5.52a7.09,7.09,0,0,1,1,3.4V91.85C433.18,93.75,432,94.66,430.49,94.17Z",
    style: {
      opacity: 0.2,
      transformOrigin: "436.69px 77.6155px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmmcjurlj7s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.45,58.2,391.19,30.11a7.48,7.48,0,0,0-6.89,0l-2.8,1.63a7.83,7.83,0,0,0-3.19,4.37c.51-1.18,1.74-1.51,3.19-.66l48.26,28.1a6.87,6.87,0,0,1,2.43,2.6l9.55-5.57A7,7,0,0,0,439.45,58.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "410.025px 47.7097px"
    },
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-277",
    className: "animable",
    style: {
      transformOrigin: "406.069px 63.0812px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.06,51.2l.53-4c0-.12.05-.19.1-.21a.16.16,0,0,1,.15,0l1.08.63a.36.36,0,0,1,.13.16.44.44,0,0,1,.05.22v.1L392,55.54a.33.33,0,0,1-.13.25.24.24,0,0,1-.28,0l-.69-.39a.73.73,0,0,1-.26-.31,1.77,1.77,0,0,1-.15-.42l-.62-3.23L389.28,54a.48.48,0,0,1-.14.25.21.21,0,0,1-.27,0l-.68-.39a.83.83,0,0,1-.29-.32,1.16,1.16,0,0,1-.13-.4l-1.06-8.65a.41.41,0,0,1,0-.1.25.25,0,0,1,.05-.17.1.1,0,0,1,.13,0l1.08.62a.53.53,0,0,1,.16.17.86.86,0,0,1,.1.33l.53,4.6.48-2a.6.6,0,0,1,.08-.19c0-.07.11-.08.2,0l.78.45a.46.46,0,0,1,.21.26,2.75,2.75,0,0,1,.07.27Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "389.904px 50.0155px"
    },
    id: "elli89g6sxnuh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.25,55.3a1.68,1.68,0,0,0,.07.52,2,2,0,0,0,.18.41,1.22,1.22,0,0,0,.24.3,1.38,1.38,0,0,0,.25.19,1.19,1.19,0,0,0,.4.15.35.35,0,0,0,.24-.08l.13-.07a.29.29,0,0,1,.14.05l1.07.62a.4.4,0,0,1,.19.39,1,1,0,0,1-.13.39,1.06,1.06,0,0,1-.38.41,1.17,1.17,0,0,1-.67.18,2.06,2.06,0,0,1-1-.33,3.7,3.7,0,0,1-.95-.78,4.52,4.52,0,0,1-.7-1.09,6,6,0,0,1-.43-1.32,7.47,7.47,0,0,1-.14-1.52,5,5,0,0,1,.14-1.29,2,2,0,0,1,.43-.84,1.05,1.05,0,0,1,.7-.31,1.84,1.84,0,0,1,.95.29,3.33,3.33,0,0,1,1,.91,5.5,5.5,0,0,1,.69,1.2A6.41,6.41,0,0,1,398.1,55a7.55,7.55,0,0,1,.12,1.29v.36a.28.28,0,0,1-.06.2.12.12,0,0,1-.16,0Zm.74-2c-.23-.14-.4-.13-.53,0a1,1,0,0,0-.21.59l1.49.86a2.9,2.9,0,0,0-.22-.84A1.26,1.26,0,0,0,396,53.29Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "395.99px 55.0204px"
    },
    id: "elmvdton6ac1o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.87,60.78a.28.28,0,0,1-.06.2.12.12,0,0,1-.16,0l-1-.6a.45.45,0,0,1-.16-.19.71.71,0,0,1-.06-.28V51.59a.31.31,0,0,1,.06-.21.13.13,0,0,1,.16,0l1,.6a.52.52,0,0,1,.16.19.74.74,0,0,1,.06.28Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "400.15px 56.1815px"
    },
    id: "el2aupcabl86f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.55,58.92c0,.12,0,.27,0,.44s0,.32,0,.45a2.08,2.08,0,0,0,.23.87,1.29,1.29,0,0,0,.52.58.57.57,0,0,0,.42.12.36.36,0,0,0,.24-.2.38.38,0,0,1,.09-.12s.08,0,.15,0l1.08.62a.45.45,0,0,1,.16.19.59.59,0,0,1,.06.28,2.56,2.56,0,0,1-.11.54,1.37,1.37,0,0,1-.34.58,1.05,1.05,0,0,1-.67.28,1.92,1.92,0,0,1-1.08-.33,4,4,0,0,1-.86-.7,4.76,4.76,0,0,1-.7-1,5.78,5.78,0,0,1-.48-1.2,5.33,5.33,0,0,1-.19-1.32c0-.13,0-.3,0-.52s0-.37,0-.5a3.1,3.1,0,0,1,.19-1.1,1.44,1.44,0,0,1,.48-.65,1.1,1.1,0,0,1,.7-.17,1.83,1.83,0,0,1,.86.29,3.71,3.71,0,0,1,1.08.9,6,6,0,0,1,.67,1.06,4.86,4.86,0,0,1,.34,1,4.39,4.39,0,0,1,.11.66.24.24,0,0,1-.06.2.13.13,0,0,1-.16,0l-1.08-.62a.39.39,0,0,1-.15-.16,1.7,1.7,0,0,1-.09-.24,1.73,1.73,0,0,0-.24-.47,1.16,1.16,0,0,0-.42-.36c-.22-.13-.39-.14-.52,0A.82.82,0,0,0,403.55,58.92Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "404.286px 59.8025px"
    },
    id: "ele9pegshunvr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.93,63.72c0,.13,0,.3,0,.5s0,.36,0,.48a3.17,3.17,0,0,1-.18,1,1.58,1.58,0,0,1-.45.67,1.07,1.07,0,0,1-.7.23,2,2,0,0,1-.91-.3,3.88,3.88,0,0,1-.92-.76,4.88,4.88,0,0,1-.69-1,5.74,5.74,0,0,1-.46-1.19,5.47,5.47,0,0,1-.18-1.25c0-.13,0-.3,0-.5s0-.36,0-.48a3.14,3.14,0,0,1,.17-1,1.48,1.48,0,0,1,.46-.67,1.08,1.08,0,0,1,.7-.24,1.94,1.94,0,0,1,.92.3,3.58,3.58,0,0,1,.91.76,5.41,5.41,0,0,1,.7,1,5.71,5.71,0,0,1,.45,1.19A5.47,5.47,0,0,1,411.93,63.72Zm-3-.82a2.12,2.12,0,0,0,.22.89,1.45,1.45,0,0,0,.54.58c.22.13.39.14.53,0a.8.8,0,0,0,.22-.62,2.68,2.68,0,0,0,0-.42,3.17,3.17,0,0,0,0-.45,2.08,2.08,0,0,0-.22-.88,1.37,1.37,0,0,0-.53-.58.47.47,0,0,0-.54,0,.82.82,0,0,0-.22.63c0,.12,0,.26,0,.42S408.92,62.77,408.93,62.9Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "409.685px 62.9052px"
    },
    id: "elp5lgowjdqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.89,71.76a.28.28,0,0,1-.07.2.12.12,0,0,1-.16,0l-1-.57a.41.41,0,0,1-.15-.2.55.55,0,0,1-.07-.28V67.67a2.64,2.64,0,0,0-.15-1,1.08,1.08,0,0,0-.45-.53c-.19-.11-.34-.1-.44,0a1.42,1.42,0,0,0-.15.81v3.25a.31.31,0,0,1-.07.21.13.13,0,0,1-.16,0l-1-.58a.38.38,0,0,1-.15-.19.58.58,0,0,1-.07-.28V66.15a2.57,2.57,0,0,0-.15-1,1,1,0,0,0-.45-.53c-.19-.11-.34-.11-.44,0a1.21,1.21,0,0,0-.16.78v3.29a.28.28,0,0,1-.06.2.12.12,0,0,1-.16,0l-1-.6a.45.45,0,0,1-.16-.19.71.71,0,0,1-.06-.28V61.93a.28.28,0,0,1,.06-.2.11.11,0,0,1,.16,0l1,.57a.52.52,0,0,1,.16.19.74.74,0,0,1,.06.28v.29a.77.77,0,0,1,.44-.3.88.88,0,0,1,.61.15,2.56,2.56,0,0,1,.76.68,3.49,3.49,0,0,1,.56,1.07.9.9,0,0,1,.58-.4,1.11,1.11,0,0,1,.74.17,2.61,2.61,0,0,1,.66.55,3.56,3.56,0,0,1,.52.83,5.27,5.27,0,0,1,.34,1.1,7.09,7.09,0,0,1,.12,1.36Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "416.545px 66.843px"
    },
    id: "el88qljbn7vpf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.5,71a2,2,0,0,0,.07.52,1.74,1.74,0,0,0,.18.41,1.22,1.22,0,0,0,.24.3,1.43,1.43,0,0,0,.26.19.8.8,0,0,0,.39.15.33.33,0,0,0,.24-.07.42.42,0,0,1,.13-.07s.08,0,.14.05l1.08.62a.4.4,0,0,1,.18.38.84.84,0,0,1-.13.39,1.16,1.16,0,0,1-.38.42,1.23,1.23,0,0,1-.67.17,1.9,1.9,0,0,1-1-.32,3.82,3.82,0,0,1-1-.79,4.66,4.66,0,0,1-.7-1.08,6.09,6.09,0,0,1-.43-1.33,8.26,8.26,0,0,1-.14-1.52,5.33,5.33,0,0,1,.14-1.28,1.85,1.85,0,0,1,.43-.84,1,1,0,0,1,.7-.31,1.72,1.72,0,0,1,1,.29,3.38,3.38,0,0,1,1,.9,5,5,0,0,1,.7,1.21,6.29,6.29,0,0,1,.38,1.33,7.57,7.57,0,0,1,.12,1.3v.35a.29.29,0,0,1-.06.21.13.13,0,0,1-.16,0Zm.75-2c-.24-.13-.41-.13-.53,0a1,1,0,0,0-.22.59l1.49.86a2.44,2.44,0,0,0-.22-.84A1.24,1.24,0,0,0,423.25,69Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "423.196px 70.7251px"
    },
    id: "el0jczlxqi30fu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.46,68.43a.41.41,0,0,1-.15-.2.54.54,0,0,1-.07-.27V59.75a.27.27,0,0,1,.07-.21.12.12,0,0,1,.15,0l2.66,1.54a3.36,3.36,0,0,1,.93.77,3.79,3.79,0,0,1,.61,1,4.84,4.84,0,0,1,.33,1,6.08,6.08,0,0,1,.09,1,2.62,2.62,0,0,1-.05.61,1.87,1.87,0,0,1-.13.4.91.91,0,0,1-.15.23l-.13.11a3.4,3.4,0,0,1,.45,1,4.68,4.68,0,0,1,.13,1.16,4.1,4.1,0,0,1-.1,1,1.48,1.48,0,0,1-.33.7.83.83,0,0,1-.59.28,1.67,1.67,0,0,1-.89-.28ZM397.55,64a1.32,1.32,0,0,0-.13-.6,1,1,0,0,0-.37-.42l-1.28-.73V63.7l1.28.74c.16.1.29.1.37,0A.59.59,0,0,0,397.55,64Zm-1.78,3.2,1.36.79c.16.09.3.09.39,0a.59.59,0,0,0,.15-.46,1.43,1.43,0,0,0-.15-.64.92.92,0,0,0-.39-.45l-1.36-.79Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "396.72px 64.9268px"
    },
    id: "elhcay0iw5s2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.15,69.83a1.35,1.35,0,0,1,.42-1.15,1.57,1.57,0,0,1,1.35,0l1,.3a1.47,1.47,0,0,0-.11-.56.81.81,0,0,0-.37-.41c-.13-.08-.22-.11-.29-.09A.49.49,0,0,0,402,68a.15.15,0,0,1-.14,0,.42.42,0,0,1-.15-.06l-1.05-.61a.34.34,0,0,1-.14-.15.45.45,0,0,1,0-.23,1.06,1.06,0,0,1,.16-.52.91.91,0,0,1,.41-.34,1.22,1.22,0,0,1,.62-.09,1.92,1.92,0,0,1,.78.27,3.35,3.35,0,0,1,.87.7,3.79,3.79,0,0,1,.62.88,4.33,4.33,0,0,1,.36,1,4.86,4.86,0,0,1,.11,1.09v3.85a.28.28,0,0,1-.06.2.12.12,0,0,1-.16,0l-1-.6a.45.45,0,0,1-.16-.19.71.71,0,0,1-.06-.28v-.36a.75.75,0,0,1-.49.32,1.19,1.19,0,0,1-.77-.22,2.66,2.66,0,0,1-.64-.52,3.25,3.25,0,0,1-.46-.68,3.89,3.89,0,0,1-.38-1.66ZM402,71.21a.66.66,0,0,0,.34.1.46.46,0,0,0,.27-.11.53.53,0,0,0,.18-.28,1.16,1.16,0,0,0,.07-.44l-.76-.26a.48.48,0,0,0-.36,0,.34.34,0,0,0-.14.32.67.67,0,0,0,.11.39A.76.76,0,0,0,402,71.21Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "402.296px 70.0062px"
    },
    id: "el5glzgqtf2ne",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,71.93a2.75,2.75,0,0,0,0,.43,3.32,3.32,0,0,0,0,.46,2.07,2.07,0,0,0,.22.86,1.39,1.39,0,0,0,.53.59.67.67,0,0,0,.41.12.41.41,0,0,0,.24-.21.62.62,0,0,1,.09-.12.12.12,0,0,1,.15,0l1.08.62a.48.48,0,0,1,.16.2.46.46,0,0,1,.06.28,2.26,2.26,0,0,1-.1.53,1.37,1.37,0,0,1-.35.58,1.12,1.12,0,0,1-.67.29,1.87,1.87,0,0,1-1.07-.33,3.82,3.82,0,0,1-.87-.71,5.16,5.16,0,0,1-.7-1,5.7,5.7,0,0,1-.48-1.19,5.85,5.85,0,0,1-.19-1.33c0-.13,0-.3,0-.51s0-.38,0-.5a3.36,3.36,0,0,1,.19-1.11,1.41,1.41,0,0,1,.48-.64,1.06,1.06,0,0,1,.7-.18,2.18,2.18,0,0,1,.87.29,3.82,3.82,0,0,1,1.07.91,5.21,5.21,0,0,1,1,2,4.06,4.06,0,0,1,.1.66.21.21,0,0,1-.06.2.11.11,0,0,1-.16,0l-1.08-.62a.46.46,0,0,1-.15-.16l-.09-.23a1.8,1.8,0,0,0-.24-.48,1.34,1.34,0,0,0-.41-.36c-.22-.12-.4-.13-.53,0A.81.81,0,0,0,407,71.93Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "407.726px 72.8076px"
    },
    id: "elqqqgu2i9u2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.57,74.32l1.09-1.2a.35.35,0,0,1,.12-.07.22.22,0,0,1,.2,0l1.21.7a.36.36,0,0,1,.15.17.7.7,0,0,1,.05.25.31.31,0,0,1,0,.1.28.28,0,0,1-.08.1l-1.47,1.67,1.74,4a1.84,1.84,0,0,1,.06.18.36.36,0,0,1,0,.11.25.25,0,0,1-.06.19.12.12,0,0,1-.14,0l-1.23-.72a.55.55,0,0,1-.2-.17,1.38,1.38,0,0,1-.14-.24l-1.31-3v2.15a.24.24,0,0,1-.07.2.11.11,0,0,1-.15,0l-1-.6a.39.39,0,0,1-.16-.19.72.72,0,0,1-.07-.28V69.34a.28.28,0,0,1,.07-.2.13.13,0,0,1,.16,0l1,.6a.42.42,0,0,1,.15.19.61.61,0,0,1,.07.28Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "413.377px 74.8275px"
    },
    id: "eljr9yb4imv3o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.05,79a.24.24,0,0,1-.07.2s-.09,0-.15,0l-1-.6a.35.35,0,0,1-.16-.19.68.68,0,0,1-.07-.28V72.64a.29.29,0,0,1,.07-.21.13.13,0,0,1,.16,0l1,.6a.42.42,0,0,1,.15.19.61.61,0,0,1,.07.28Zm0,2.73a.27.27,0,0,1-.07.21.12.12,0,0,1-.15,0l-1-.6a.42.42,0,0,1-.16-.2.68.68,0,0,1-.07-.28V79.56a.28.28,0,0,1,.07-.2.12.12,0,0,1,.16,0l1,.6a.38.38,0,0,1,.15.19.58.58,0,0,1,.07.28Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "417.326px 77.1844px"
    },
    id: "ellp8ooz6z1gh",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sign--inject-277",
    className: "animable",
    style: {
      transformOrigin: "318.92px 137.462px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Signal--inject-277",
    className: "animable",
    style: {
      transformOrigin: "318.92px 137.462px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.36,89.34a1.31,1.31,0,0,0-.76-1,4.13,4.13,0,0,0-3.72,0,1.33,1.33,0,0,0-.77,1h0v151c0,.82,1.17,1.49,2.63,1.49s2.62-.67,2.62-1.49h0V89.34Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "315.735px 164.864px"
    },
    id: "elsb7pzm8b1g9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 315.73,
    cy: 57.09,
    rx: 3.18,
    ry: 1.8,
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "315.73px 57.09px"
    },
    id: "ely8vn2553cy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "344.4 127.29 338.15 116.46 296.58 92.48 293.44 94.3 293.44 108.73 335 132.71 338.21 130.94 344.4 127.29",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "318.92px 112.595px"
    },
    id: "elc1zkgjns1u7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "293.44 94.3 335 118.28 341.26 129.1 335 132.71 293.44 108.73 293.44 94.3",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "317.35px 113.505px"
    },
    id: "elunw6ouoers",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el27xmxxrnin7"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "338.15 116.46 335 118.28 293.44 94.3 296.58 92.48 338.15 116.46",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "315.795px 105.38px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "else6zsizehxs"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "335 118.28 338.15 116.46 344.4 127.29 341.27 129.13 335 118.28",
    style: {
      opacity: 0.1,
      transformOrigin: "339.7px 122.795px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--school-signal--inject-277",
    className: "animable",
    style: {
      transformOrigin: "317.842px 69.7115px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.39,78.62a8.46,8.46,0,0,0-1.05-4q-6.51-12.73-13-25.52-3.6-7.08-7.19-14.17a3.12,3.12,0,0,0-1.64-1.75.86.86,0,0,0-.73.08c-.17.1-1.81,1.1-2,1.18a2.51,2.51,0,0,0-.55.39l-9.6,7.84-10.62,8.66a2,2,0,0,0-.71,1.69q0,12.71,0,25.39a4.67,4.67,0,0,0,2.27,4.25l17.62,10.17,4.56,2.63L337.14,106a1.55,1.55,0,0,0,1.42.24c.15-.08,1.65-1,2-1.19a1,1,0,0,0,.42-.37,3.3,3.3,0,0,0,.38-1.89C341.37,94.74,341.35,86.66,341.39,78.62Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "317.842px 69.7248px"
    },
    id: "elvsj4tlxhg9a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elbgdjvm0t6x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341,76.19a10.53,10.53,0,0,0-.66-1.61q-6.51-12.73-13-25.52-3.6-7.08-7.19-14.17a3.12,3.12,0,0,0-1.64-1.75.86.86,0,0,0-.73.08c-.17.1-1.81,1.1-2,1.18a2.51,2.51,0,0,0-.55.39l-9.6,7.84-10.62,8.66a2,2,0,0,0-.71,1.69q0,12.71,0,25.39a4.67,4.67,0,0,0,2.27,4.25l17.62,10.17-1-.57Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "317.647px 62.9415px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elmqye3rummw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.39,78.62a7.88,7.88,0,0,0-.1-1.2.29.29,0,0,0,0-.09,7.85,7.85,0,0,0-.27-1.14h0l-27.75,16,1,.57,4.56,2.63L337.14,106a2,2,0,0,0,1.11.33,1.11,1.11,0,0,0,.31-.09l.93-.56.33-.2c.32-.19.62-.37.75-.43l.11-.07a1.1,1.1,0,0,0,.31-.3,3.3,3.3,0,0,0,.38-1.89C341.37,94.74,341.35,86.66,341.39,78.62Z",
    style: {
      opacity: 0.2,
      transformOrigin: "327.33px 91.26px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.35,79.81a8.36,8.36,0,0,0-1-4q-6.51-12.73-13-25.51-3.6-7.09-7.19-14.18a3.15,3.15,0,0,0-1.64-1.75c-.53-.16-.87.17-1.23.46l-9.6,7.84-10.62,8.66a2,2,0,0,0-.71,1.69q0,12.71,0,25.39a4.67,4.67,0,0,0,2.27,4.25l17.62,10.17,4.56,2.63L337.14,106c.76.43,1.39.49,1.82-.13a3.37,3.37,0,0,0,.38-1.89Q339.33,91.9,339.35,79.81Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "316.854px 70.3287px"
    },
    id: "el4sv0fvjo06",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.78,92.05,298.57,81.54A4.76,4.76,0,0,1,296.19,77V54.89a2.63,2.63,0,0,1,.73-2.14q9.24-7.5,18.45-15c1-.84,1.92-.33,3,1.72q9.21,18.15,18.44,36.32a6.21,6.21,0,0,1,.73,2.84q0,11.24,0,22.46c0,1.89-.83,2.47-2.27,1.64Q326,97.39,316.78,92.05Zm.05-.53,18.32,10.58c1.31.75,1.92.3,1.92-1.45,0-7.36,0-14.72,0-22.07a6,6,0,0,0-.73-2.81q-9.23-18.15-18.43-36.31c-.74-1.47-1.41-1.84-2.17-1.23q-9.19,7.5-18.4,15a2.42,2.42,0,0,0-.74,2c0,7.34,0,14.67,0,22A3.84,3.84,0,0,0,298.56,81Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "316.856px 70.2313px"
    },
    id: "elhqsgqivdpqs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.27,78.28c-.22,1.08-.44,2-.61,3a1.35,1.35,0,0,1-.4.79,7.42,7.42,0,0,0-1.55,1.88,1.41,1.41,0,0,0,.09,1.59,1,1,0,0,1,.14.87c-.13.21-.36-.1-.54-.28-1.56-1.5-1.75-2.19-.93-3.6A24.49,24.49,0,0,1,321,80.34,1.76,1.76,0,0,0,321.2,79,19.38,19.38,0,0,1,321,75.7a1.12,1.12,0,0,0-.37-1c-.45-.45-.89-.92-1.34-1.37a.7.7,0,0,1-.26-.71c.11-.49.16-1,.25-1.55.05-.25,0-.7.4-.3.13.13.16,0,.17-.15l.09-1.75a.55.55,0,0,0-.19-.44c-1.51-1.45-2.43-3.67-3.62-5.53a2.88,2.88,0,0,0-.59-.83c-.15,1.29-.32,2.55-.45,3.85a3.59,3.59,0,0,0,.15.91q.86,3.89,1.72,7.77a2.82,2.82,0,0,1,.05,1.25c-.4,1.91-.76,3.85-1.16,5.75a1.77,1.77,0,0,0,.46,1.51c.84,1,1.06,1.55.92,2.21,0,0-.94-.67-1.35-1-1-.84-1.83-1.47-1.83-1.47s.12-1,.22-2c.16-1.8.35-3.59.54-5.38a6.27,6.27,0,0,0-.11-2c-.3-1.36-.56-2.72-.87-4.28-.32,1.55-.61,2.93-.87,4.34a2.35,2.35,0,0,1-.68,1.39,16.13,16.13,0,0,0-2.83,3.53A14.88,14.88,0,0,0,310.2,80a2,2,0,0,1,.25.92c0,.41-.06.68-.49.27-.6-.6-2.1-2.6-2.64-3.35.1-.5.47-.8.54-1.1.84-1.3,1.21-2.1,2-3.18s1.07-2.83.79-5c-.14-1.13-.17-2.24-.21-3.33a1.47,1.47,0,0,0-.48-1.11c-.72-.7-1.41-1.47-2.13-2.17a.79.79,0,0,1-.29-.84c.16-.88.29-1.79.42-2.7,0-.35.1-.63.47-.15.26.32.37.22.34-.15a8.51,8.51,0,0,1,1.66-5.62,2.17,2.17,0,0,1,1.93-1,1,1,0,0,1,.68.37c.5.47,1,1,1.48,1.38a3.84,3.84,0,0,1,1.23,2.12,30.2,30.2,0,0,1,.92,4.58A12.33,12.33,0,0,0,319,65.62c.37.55.8,1,1.17,1.59.26.38.38.44.52.13a2,2,0,0,1,.67-.9c.54-.36,1.1-.34,1.91.4a4.88,4.88,0,0,1,1.6,3c.11.62.28,1.27.33,1.87a8.69,8.69,0,0,0,2,4.54,8.08,8.08,0,0,1,.92,1.38c.14.3.21.57.07.75s-.28-.08-.42-.24a10.48,10.48,0,0,1-2-2.64c-.36-.71-.8-1.38-1.3-2.23-.12,1.43-.55,2.53,0,4.22,0,0,0,0,0,.08a13.74,13.74,0,0,1,.29,8.71,1.25,1.25,0,0,0,.37,1.48,1.12,1.12,0,0,1,.37.93c-.08.33-.35.07-.56,0-1.37-.76-1.46-.94-1.33-2.67a22.74,22.74,0,0,1,.26-2.58C324.16,81.91,323.66,80.16,323.27,78.28ZM311.15,56.54c-1.34-.25-1.51,1.08-1.51,2.64,0,.67.48.75.72,1.11s.19.06.22-.09C310.77,59,311,57.73,311.15,56.54Zm10.31,13.09c-.91-.18-1,.7-1,1.68a.91.91,0,0,0,.42.76c.24.23.22,0,.25-.23C321.22,71.11,321.34,70.39,321.46,69.63Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "317.793px 70.1706px"
    },
    id: "elftq77zsuiw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.52,50.62c0,1.5-1,2.17-2.11,1.49a5,5,0,0,1-2.06-3.86c-.07-1.64.92-2.44,2.12-1.71A5.06,5.06,0,0,1,316.52,50.62Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "314.433px 49.3222px"
    },
    id: "elhr8386qm60p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.1,65.83c-.1.7-.53,1.06-1.09.9a3.2,3.2,0,0,1-1.73-3c.06-.81.56-1.23,1.19-1A3.24,3.24,0,0,1,325.1,65.83Z",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "323.694px 64.7175px"
    },
    id: "elukqx71rvw9k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.23 95 305.49 81.87 305.49 80.7 328.23 93.83 328.23 95",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "316.86px 87.85px"
    },
    id: "elnrvy33is7wh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "333.76 84.6 325.57 79.87 325.57 78.7 333.76 83.43 333.76 84.6",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "329.665px 81.65px"
    },
    id: "ele3m67n97xrc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.42 76.9 317.51 75.22 317.51 74.05 320.42 75.73 320.42 76.9",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "318.965px 75.475px"
    },
    id: "eltzbnaosw2y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.88 70.81 299.82 65 299.82 63.84 309.88 69.64 309.88 70.81",
    style: {
      fill: "rgb(55, 71, 79)",
      transformOrigin: "304.85px 67.325px"
    },
    id: "elf57pq527gb5",
    className: "animable"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-277",
    className: "animable",
    style: {
      transformOrigin: "87.505px 81.7792px"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--clouds--inject-277",
    className: "animable",
    style: {
      transformOrigin: "87.505px 81.7792px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.69,60.06l-7.27,4.2c0-.33.06-.65.06-1v-2.1c0-3.75-2.64-5.27-5.88-3.4a11.33,11.33,0,0,0-3.51,3.37c-.53-4.71-4.23-6.47-8.72-3.88-4.86,2.81-8.8,9.63-8.8,15.24v3.15a8.23,8.23,0,0,0,.75,3.65l-6,3.49A7.21,7.21,0,0,0,39,88.46c0,2.08,1.46,2.92,3.26,1.88L81.69,67.59A7.21,7.21,0,0,0,85,61.94C85,59.86,83.49,59,81.69,60.06Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "62px 73.4198px"
    },
    id: "elj3nm7lmh6p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.81,69.5l-4,1.54V62.2c0-7-5.59-8.68-11.66-5.18h0c-6.06,3.5-11,12-11,19v1.28a5.86,5.86,0,0,0-5.1.79h0a17.46,17.46,0,0,0-7.91,13.69v.58l-5.59,3.23a11.5,11.5,0,0,0-5.21,9c0,3.32,2.33,4.67,5.21,3l45.25-26.13a11.5,11.5,0,0,0,5.21-9C136,69.18,133.69,67.84,130.81,69.5Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "108.175px 81.7792px"
    },
    id: "elak27vlifpef",
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentsp);
export default __webpack_public_path__ + "static/media/parentsp.109a5c4c0927ed39f9c9b46e50b64614.svg";
export { ForwardRef as ReactComponent };